import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../partner/common/api/converter/partnerSummary.converter';
import {ValueAndLabelConverter} from '../../../../common/converter/ValueAndLabel.converter';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {DocumentSummaryModel} from '../model/documentSummary.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentSummaryConverter extends HttpModelConverter<DocumentSummaryModel> {

    constructor(private partnerSummaryConverter: PartnerSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private valueAndLabelConverter: ValueAndLabelConverter) {
        super();
    }
    protected createInstance(): DocumentSummaryModel {
        return new DocumentSummaryModel();
    }

    protected enrichObject(result: DocumentSummaryModel, src: DocumentSummaryModel) {
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.category = this.lovValueSummaryConverter.convert(src.category);
        result.format = this.valueAndLabelConverter.convert(src.format);
    }
}
